module.exports = __webpack_public_path__ + "img/icon-success.e09f7f41.png";